import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

import { findLatLngSelector } from '../../../features/map/mapSlice';


const OsmFindLatLngMarker = () => {

    const map = useMap();
    const markerData = useSelector(findLatLngSelector);
    let icon = `/assets/history/def40/endflag.png`;
    const [theIcon, setTheIcon] = useState(null);

    const createMarker = useCallback(
        () => {
            if (markerData) {
                if (markerData.lat && markerData.lng) {
                    const tic = L.marker(
                        [parseFloat(markerData.lat), parseFloat(markerData.lng)],
                        {
                            icon: L.icon({
                                iconUrl: icon,
                                iconSize: [20, 20]
                            })
                        }
                    );
                    map.addLayer(tic);
                    setTheIcon(tic);
                }
            }
        },
        [icon, map, markerData],
    )


    useEffect(() => {
        if (!theIcon) {
            createMarker();
        }
        return () => {
            if (theIcon) {
                map.removeLayer(theIcon);
                setTheIcon(null);
            }
        }
    }, [theIcon, map, createMarker])

    return null;

}

export default React.memo(OsmFindLatLngMarker);
